import { useState, useCallback } from "react";

/**
 * Custom hook for managing form states
 * Consolidates all form-related state and handlers
 */
export const useFormState = () => {
  // Add item form state
  const [itemSearchTerm, setItemSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [showItemOptions, setShowItemOptions] = useState(false);
  const [serialSearchTerm, setSerialSearchTerm] = useState("");
  const [selectedSerial, setSelectedSerial] = useState(null);
  const [showSerialOptions, setShowSerialOptions] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [note, setNote] = useState("");

  // Form handlers
  const resetAddItemForm = useCallback(() => {
    setItemSearchTerm("");
    setSelectedItem(null);
    setShowItemOptions(false);
    setSerialSearchTerm("");
    setSelectedSerial(null);
    setShowSerialOptions(false);
    setQuantity(1);
    setNote("");
  }, []);

  const handleItemSelect = useCallback((item) => {
    setSelectedItem(item);
    setShowItemOptions(false);
    setSelectedSerial(null);
    setSerialSearchTerm("");
  }, []);

  const handleSerialSelect = useCallback((serial) => {
    setSelectedSerial(serial);
    setShowSerialOptions(false);
  }, []);

  const handleItemInputChange = useCallback((e) => {
    setItemSearchTerm(e.target.value);
    setShowItemOptions(true);
  }, []);

  const handleSerialInputChange = useCallback((e) => {
    setSerialSearchTerm(e.target.value);
    setShowSerialOptions(true);
  }, []);

  const handleQuantityChange = useCallback((e) => {
    setQuantity(parseInt(e.target.value) || 1);
  }, []);

  const handleNoteChange = useCallback((e) => {
    setNote(e.target.value);
  }, []);

  const handleItemInputFocus = useCallback(() => {
    setShowItemOptions(true);
  }, []);

  const handleItemInputBlur = useCallback(() => {
    // Delay hiding options to allow for clicks
    setTimeout(() => {
      setShowItemOptions(false);
    }, 200);
  }, []);

  const handleSerialInputFocus = useCallback(() => {
    setShowSerialOptions(true);
  }, []);

  const handleSerialInputBlur = useCallback(() => {
    // Delay hiding options to allow for clicks
    setTimeout(() => {
      setShowSerialOptions(false);
    }, 200);
  }, []);

  return {
    // Form states
    itemSearchTerm,
    selectedItem,
    showItemOptions,
    serialSearchTerm,
    selectedSerial,
    showSerialOptions,
    quantity,
    note,

    // Form handlers
    resetAddItemForm,
    handleItemSelect,
    handleSerialSelect,
    handleItemInputChange,
    handleSerialInputChange,
    handleQuantityChange,
    handleNoteChange,
    handleItemInputFocus,
    handleItemInputBlur,
    handleSerialInputFocus,
    handleSerialInputBlur,

    // Setters for direct control
    setItemSearchTerm,
    setSelectedItem,
    setShowItemOptions,
    setSerialSearchTerm,
    setSelectedSerial,
    setShowSerialOptions,
    setQuantity,
    setNote,
  };
};
